import React from 'react';
import { VoiceTab } from '@avatar/contexts/tabs';
import { useCanShowAdditionalLanguagesUpsell } from 'abilities/projects';
import { ModalProps } from '../../Modal';
import ProjectCreateModalV2 from '../../ProjectsV2/Create/modal/Modal';
import { useUserContext } from '../../../context/user/UserContext';
import { StudioProjectVersion } from '../../../../server/graphql/__generated.types';
import { ProjectCreationSource } from '../../../services/eventTrackingServiceTypes';

export interface ProjectCreationModalProps
  extends Pick<ModalProps, 'open' | 'onClose'> {
  folderId?: string;
  driveId?: string;
  source: ProjectCreationSource;
  enabledVersions?: Array<StudioProjectVersion>;
  onSuccess: (projectId: string, projectVersion?: StudioProjectVersion) => void;
  tab?: VoiceTab;
  variantId?: string;
}

const ProjectCreationModal = ({
  open,
  onClose,
  onSuccess,
  enabledVersions,
  folderId,
  driveId,
  source,
  tab,
  variantId,
}: ProjectCreationModalProps) => {
  const { data } = useUserContext();
  const studioProjectVersions = data?.user.studioProjectVersions;
  const hasAdditonalLanguagesEnabled = studioProjectVersions?.some(v =>
    v.includes('azure')
  );
  const canShowAdditionalLanguagesUpsell = useCanShowAdditionalLanguagesUpsell(
    studioProjectVersions
  );

  return (
    <ProjectCreateModalV2
      userVersions={studioProjectVersions || []}
      enabledVersions={enabledVersions}
      open={open}
      onClose={onClose}
      onSuccess={onSuccess}
      source={source}
      isAdditionalLanguagesUpgrade={
        canShowAdditionalLanguagesUpsell && !hasAdditonalLanguagesEnabled
      }
      folderId={folderId}
      driveId={driveId}
      tab={tab}
      variantId={variantId}
    />
  );
};

export default ProjectCreationModal;
